import { createBrowserRouter, Navigate } from "react-router-dom";

import AuthLayout from "../pages/auth/AuthLayout/AuthLayout";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

import Login from "../pages/auth/Login/Login";
import SignUp from "../pages/auth/Signup/Signup";
import ForgotPassword from "../pages/auth/ForgotPassword/ForgotPassword";
import ConfirmationCode from "../pages/auth/ConfirmationCode/ConfirmationCode";
import ForgotConfirmationCode from "../pages/auth/ForgotConfirmationCode/ForgotConfirmationCode";
import ResetPassword from "../pages/auth/ResetPassword/ResetPassword";
import UserType from "../pages/auth/UserType/UserType";
import ProfileSetup from "../pages/instructor/ProfileSetup/ProfileSetup";
import Organization from "../pages/auth/OrganizationSignup/OrganizationSignup";
import StudentDashboard from "../pages/student/StudentDashboard/StudentDashboard";
import AddEducation from "../pages/student/AddEducation/AddEducation";
import AddExperience from "../pages/student/AddExperience/AddExperience";
import DashboardLayout from "../pages/student/DashboardLayout/DashboardLayout";
import InstructorAddEducation from "../pages/instructor/InstructorAddEducation/InstructorAddEducation";
import InstructorAddExperience from "../pages/instructor/InstructorAddExperience/InstructorAddExperience";
import InstructureDashboard from "../pages/instructor/InstructureDashboard/InstructureDashboard";
import InstructorAddCourses from "../pages/instructor/InstructorAddCourses/InstructorAddCourses";
import InstructorCourses from "../pages/instructor/InstructorCourses/InstructorCourses";
import CourseDetail from "../pages/instructor/CourseDetails/CourseDetails";
import AdminDashboard from "../pages/admin/AdminDashboard/AdminDashboard";
import AdminAddCourses from "../pages/admin/AdminAddCourses/AdminAddCourses";
import AdminCourses from "../pages/admin/AdminCourses/AdminCourses";
import AdminCourseDetails from "../pages/admin/AdminCourseDetails/AdminCourseDetails";
import AdminStudentNotebook from "../pages/admin/AdminStudentNotebook/AdminStudentNotebook";
import LandingPage from "../pages/landingPage/landingPage";
import LandingPageLayout from "../pages/landingPage/ladingPageLayout/landingPageLayout";
import Students from "../pages/instructor/Students/Students";
import RoleBasedSettings from "../components/Settings/RoleBasedSettings";
// import InstructorProfile from "../pages/instructor/InstructorProfile/InstructorProfile";
import AssignmentTable from "../pages/instructor/AssignmentTable/AssignmentTable";
import EditProfile from "../components/InstructorProfile/EditProfile/EditProfile";
import Instructors from "../pages/admin/Instructors/Instructors";
import StudentDetails from "../pages/admin/StudentDetails/StudentDetails";
import AdminStudents from "../pages/admin/Students/Students";
import InstructorDetails from "../pages/admin/InstructorDetails/InstructorDetails";
import OrganizationRequests from "../pages/admin/Organizations/OrganizationsRequests";
import DeactivatedUsers from "../pages/admin/DeactivatedUsers/DeactivatedUsers";
import Profile from "../pages/admin/Profile/Profile";
import StudentCourses from "../pages/student/StudentCourse/StudentCourses";
import StudentCourseDetail from "../pages/student/StudentCourseDetail/StudentCourseDetail";
import StudentEnrollCourse from "../pages/student/StudentEnrollCourse/StudentEnrollCourse";
import StudentCourseVideos from "../pages/student/StudentCourseVideos/StudentCourseVideos";
import Assignments from "../pages/student/Assignments/Assignments";
import AssignmentMarking from "../pages/instructor/AssgimentMarking/AssgimentMarking";
import CertifyMe from "../pages/student/CertifyMe/CertifyMe";
import AssessMe from "../pages/student/AssessMe/AssessMe";
import GrownthCoordinator from "../pages/student/GrowthCoordinator/GrowthCoordinator";
import HelpCenter from "../pages/Common/HelpCenter/HelpCenter";
import PricingPlan from "../pages/auth/PricingPlan/PricingPlan";
import RequestCourses from "../pages/instructor/RequestCourses/RequestCourses";
import RequestCoursesAdmin from "../pages/admin/RequestCoursesAdmin/RequestCoursesAdmin";
import DeactivatedStudents from "../pages/instructor/DeactivatedStudents/DeactivatedStudents";
import StudentEnrolledCourseForAdmin from "../pages/admin/StudentEnrolledCourseForAdmin/StudentEnrolledCourseForAdmin";
import StudentCourseViewDetail from "../pages/admin/StudentCourseViewDetail/StudentCourseViewDetail";
import Checkout from "../pages/auth/checkout/Checkout";
import StudentCertificates from "../pages/student/StudentCertificate/StudentCertificates";
import StudentCertificateDetail from "../pages/student/StudentCertificateDetail/StudentCertificateDetail";
import AttestedCertificates from "../pages/student/AttestedCertificates/AttestedCertificates";
import RequestedCertificate from "../pages/student/RequestedCertificate/RequestedCertificate";
import StudentCourseNew from "../pages/student/StudentCourseNew/StudentCourseNew";
import CertificateRequestes from "../pages/instructor/CertificateRequestes/CertificateRequestes";
import CertificateRequests from "../pages/admin/CertificateRequests/CertificateRequests";
import ManageSubscription from "../pages/student/ManageSubscription/ManageSubscription";
import StudentCheckout from "../pages/student/StudentCheckout/StudentCheckout";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPageLayout />,
    children: [{ index: true, element: <LandingPage /> }],
  },
  {
    element: <PublicRoute />,
    children: [
      {
        path: "/",
        element: <AuthLayout />,
        children: [
          { path: "login", element: <Login /> },
          { path: "signup", element: <SignUp /> },
          { path: "forgot-password", element: <ForgotPassword /> },
          { path: "confirmation-code", element: <ConfirmationCode /> },
          {
            path: "forgot-confirmation-code",
            element: <ForgotConfirmationCode />,
          },
          { path: "user-type", element: <UserType /> },
          { path: "organization", element: <Organization /> },
          { path: "*", element: <Navigate to="/login" replace /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={["instructor"]} />,
    children: [
      {
        path: "/",
        element: <AuthLayout />,
        children: [
          { path: "profile-setup", element: <ProfileSetup /> },
          {
            path: "instructor-add-education",
            element: <InstructorAddEducation />,
          },
          {
            path: "instructor-add-experience",
            element: <InstructorAddExperience />,
          },
          { path: "instructor-reset-password", element: <ResetPassword /> },
        ],
      },
      {
        path: "/", 
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="instructor-dashboard" replace />,
          },
          { path: "instructor-dashboard", element: <InstructureDashboard /> },
          { path: "instructor-add-course", element: <InstructorAddCourses /> },
          { path: "instructor-courses", element: <InstructorCourses /> },
          { path: "instructor-course-detail", element: <CourseDetail /> },
          { path: "instructor-student", element: <Students /> },
          { path: "instructor-request-course", element: <RequestCourses /> },
          {
            path: "instructor-deactivated-students",
            element: <DeactivatedStudents />, 
          },
          { path: "instructor-certificates-requests", element: <CertificateRequestes /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={["student"]} />,
    children: [
      {
        path: "/",
        element: <AuthLayout />,
        children: [
          { path: "add-education", element: <AddEducation /> },
          { path: "add-experience", element: <AddExperience /> },
          { path: "student-reset-password", element: <ResetPassword /> },
          { path: "choose-plan", element: <PricingPlan /> },
          { path: "checkout", element: <Checkout /> },
        ],
      },
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { index: true, element: <Navigate to="student-dashboard" replace /> },
          { path: "student-dashboard", element: <StudentDashboard /> },
          { path: "student-courses", element: <StudentCourses /> },
          // { path: "student-courses-detail", element: <StudentCourseDetail /> },
          { path: "student-enroll-course", element: <StudentEnrollCourse /> },
          { path: "student-course-videos", element: <StudentCourseVideos /> },
          { path: "attempt-assignment", element: <Assignments /> },
          { path: "certifyMe", element: <CertifyMe /> },
          { path: "assessMe", element: <AssessMe /> },
          { path: "growth-coordinator", element: <GrownthCoordinator /> },
          { path: "student-certificates", element: <StudentCertificates /> },
          {
            path: "student-requested-certificate",
            element: <RequestedCertificate />,
          },
          {
            path: "student-attested-certificates",
            element: <AttestedCertificates />,
          },
          { path: "manage-subscription", element: <ManageSubscription /> },
          { path: "student-checkout", element: <StudentCheckout /> },
        ],
      },
      {
        path: "/ai-course-creation-flow",
        element: <StudentCourseNew />,
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={["admin"]} />,
    children: [
      {
        path: "/",
        element: <AuthLayout />,
        children: [
          { path: "admin-reset-password", element: <ResetPassword /> },
        ],
      },
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { path: "admin-dashboard", element: <AdminDashboard /> },
          { path: "admin-new-course", element: <AdminAddCourses /> },
          { path: "admin-courses", element: <AdminCourses /> },
          { path: "admin-course-detail", element: <AdminCourseDetails /> },
          
          { path: "instructor", element: <Instructors /> },
          { path: "students", element: <AdminStudents /> },
          {
            path: "admin-organization-requests",
            element: <OrganizationRequests />,
          },
          { path: "admin-deactivated-users", element: <DeactivatedUsers /> },
          { path: "admin-request-course", element: <RequestCoursesAdmin /> },
          {
            path: "admin-certificates-requests",
            element: <CertificateRequests />,
          },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={["admin", "instructor"]} />,
    children: [
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { path: "instructor-details", element: <InstructorDetails /> },
          { path: "student-details", element: <StudentDetails /> },
          { path: "student-assignments", element: <AssignmentTable /> },
          { path: "course-view", element: <StudentEnrolledCourseForAdmin /> },
          { path: "assignment-marking", element: <AssignmentMarking /> },
          {
            path: "student-course-view-detail",
            element: <StudentCourseViewDetail />,
          },
          { path: "view-assignment", element: <Assignments /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={["admin", "student", "instructor"]} />,
    children: [
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { path: "student-courses-detail", element: <StudentCourseDetail /> },
          {
            path: "student-certificates-detail",
            element: <StudentCertificateDetail />,
          },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute allowedRoles={["admin", "instructor"]} />,
    children: [
      {
        path: "/",
        children: [
          { path: "admin-student-notebook", element: <AdminStudentNotebook /> },
        ],
      },
    ],
  },
  {
    element: (
      <ProtectedRoute allowedRoles={["admin", "instructor", "student"]} />
    ),
    children: [
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { path: "edit-profile", element: <EditProfile /> },
          { path: "profile", element: <Profile /> },
          { path: "settings", element: <RoleBasedSettings /> },
          { path: "help-center", element: <HelpCenter /> },
        ],
      },
    ],
  },
]);

export default router;
